import { useTranslation } from 'react-i18next'

import * as SvgIcons from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'
import { type NewReelPayload, useShareReel } from 'services/reels'

interface ShareReelProps {
  reel: NewReelPayload
  onSuccess?: () => void
  disabled?: boolean
}

export const ShareReel = ({
  reel,
  onSuccess,
  disabled = false
}: ShareReelProps) => {
  const { t } = useTranslation()

  const { handleShareClick, isSubmitting } = useShareReel({
    reel,
    onSuccess
  })

  return (
    <Button
      text={t('share')}
      color="blue"
      padding="5"
      width="fit"
      height="5"
      font="mont-14-normal"
      prevIcon={<SvgIcons.IconPlusInCircleDashed />}
      clickFn={handleShareClick}
      disabled={disabled || isSubmitting}
    />
  )
}